import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-center w-100" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "text-h6 font-weight-bold mb-3 mt-0" }
const _hoisted_4 = {
  key: 0,
  class: "text-body-2 font-weight-medium mb-1"
}
const _hoisted_5 = {
  key: 1,
  class: "text-body-2 font-weight-medium mb-3"
}
const _hoisted_6 = { class: "whitespace-pre-line" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "svgContainer",
      class: "w-100",
      innerHTML: _ctx.svgContent
    }, null, 8, _hoisted_2),
    (_ctx.tooltipVisible)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          class: _normalizeClass(["position-fixed elevation-8 rounded-lg pa-4 bg-amber-lighten-5 bottom-[40px] right-[24px] w-[340px] z-[1000] pointer-events-none transition-opacity", { 'opacity-100': _ctx.tooltipVisible, 'opacity-0': !_ctx.tooltipVisible }])
        }, {
          default: _withCtx(() => [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.popupData.name), 1),
            (_ctx.popupData.model)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Model: " + _toDisplayString(_ctx.popupData.model), 1))
              : _createCommentVNode("", true),
            (_ctx.popupData.score)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Score: " + _toDisplayString(_ctx.popupData.score), 1))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.popupData.detail), 1)
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true)
  ]))
}